import navbarInit from './navbar';

window.onload = async () => {
  if (document.getElementsByClassName('slider').length) {
    import('./slider').then((module) => module.default());
  }
  if (document.getElementsByClassName('upload').length) {
    import('./upload').then((module) => module.default());
  }
  if (document.getElementsByClassName('single-downloads').length) {
    import('./download').then((module) => module.default());
  }
};

document.addEventListener('DOMContentLoaded', () => {
  import(/* webpackPrefetch: true */ './icons');
  navbarInit();
});
